import { render, staticRenderFns } from "./informe_respuestas.vue?vue&type=template&id=2ee3b238&scoped=true"
import script from "./informe_respuestas.vue?vue&type=script&lang=js"
export * from "./informe_respuestas.vue?vue&type=script&lang=js"
import style0 from "./informe_respuestas.vue?vue&type=style&index=0&id=2ee3b238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3b238",
  null
  
)

export default component.exports